import deleteById from '../../helpers/deleteById'

const FETCHING_GROUPS = 'FETCHING_GROUPS'
const FETCHING_GROUPS_FAILURE = 'FETCHING_GROUPS_FAILURE'
const FETCHING_GROUPS_SUCCESS = 'FETCHING_GROUPS_SUCCESS'
const CREATING_GROUPS = 'CREATING_GROUPS'
const CREATING_GROUPS_FAILURE = 'CREATING_GROUPS_FAILURE'
const CREATING_GROUPS_SUCCESS = 'CREATING_GROUPS_SUCCESS'
const G_FETCHING_USERS = 'G_FETCHING_USERS'
const G_FETCHING_USERS_SUCCESS = 'G_FETCHING_USERS_SUCCESS'
const G_FETCHING_USERS_ERROR = 'G_FETCHING_USERS_ERROR'
const GMEMB_SET_ACTIVE_GROUP = 'GMEMB_SET_ACTIVE_GROUP'
const GMEMB_ADDING_MEMBER = 'GMEMB_ADDING_MEMBER'
const GMEMB_ADDING_MEMBER_SUCCESS = 'GMEMB_ADDING_MEMBER_SUCCESS'
const GMEMB_ADDING_MEMBER_ERROR = 'GMEMB_ADDING_MEMBER_ERROR'
const GMEMB_REMOVING_MEMBER = 'GMEMB_REMOVING_MEMBER'
const GMEMB_REMOVING_MEMBER_SUCCESS = 'GMEMB_REMOVING_MEMBER_SUCCESS'
const GMEMB_REMOVING_MEMBER_ERROR = 'GMEMB_REMOVING_MEMBER_ERROR'
const GMEMB_ADDING_MANAGER = 'GMEMB_ADDING_MANAGER'
const GMEMB_ADDING_MANAGER_SUCCESS = 'GMEMB_ADDING_MANAGER_SUCCESS'
const GMEMB_ADDING_MANAGER_ERROR = 'GMEMB_ADDING_MANAGER_ERROR'
const GMEMB_REMOVING_MANAGER = 'GMEMB_REMOVING_MANAGER'
const GMEMB_REMOVING_MANAGER_SUCCESS = 'GMEMB_REMOVING_MANAGER_SUCCESS'
const GMEMB_REMOVING_MANAGER_ERROR = 'GMEMB_REMOVING_MANAGER_ERROR'

export function fetchingGroups () {
  return {
    type: FETCHING_GROUPS,
  }
}

export function fetchingGroupsFailure (error) {
  return {
    type: FETCHING_GROUPS_FAILURE,
    error,
  }
}

export function fetchingGroupsSuccess (groupsList) {
  return {
    type: FETCHING_GROUPS_SUCCESS,
    groupsList,
  }
}

export function creatingGroups () {
  return {
    type: CREATING_GROUPS,
  }
}

export function creatingGroupsFailure (error) {
  return {
    type: CREATING_GROUPS_FAILURE,
    error,
  }
}

export function creatingGroupsSuccess (groupCreated) {
  return {
    type: CREATING_GROUPS_SUCCESS,
  }
}

export function fetchingUsers() {
  return {
    type: G_FETCHING_USERS,
  }
}

export function fetchingUsersSuccess(users) {
  return {
    type: G_FETCHING_USERS_SUCCESS,
    users,
  }
}

export function fetchingUsersError(error) {
  return {
    type: G_FETCHING_USERS_ERROR,
    error,
  }
}

export function setActiveGroup(activeGroup) {
  return {
    type: GMEMB_SET_ACTIVE_GROUP,
    activeGroup,
  }
}

export function addingMember() {
  return {
    type: GMEMB_ADDING_MEMBER,
  }
}

export function addingMemberSuccess(memberId) {
  return {
    type: GMEMB_ADDING_MEMBER_SUCCESS,
    memberId,
  }
}

export function addingMemberError(error) {
  return {
    type: GMEMB_ADDING_MEMBER_ERROR,
    error,
  }
}

export function removingMember() {
  return {
    type: GMEMB_REMOVING_MEMBER,
  }
}

export function removingMemberSuccess(memberId) {
  return {
    type: GMEMB_REMOVING_MEMBER_SUCCESS,
    memberId,
  }
}

export function removingMemberError (error) {
  return {
    type: GMEMB_REMOVING_MEMBER_ERROR,
    error,
  }
}

export function addingManager() {
  return {
    type: GMEMB_ADDING_MANAGER,
  }
}

export function addingManagerSuccess(memberId) {
  return {
    type: GMEMB_ADDING_MANAGER_SUCCESS,
    memberId,
  }
}

export function addingManagerError(error) {
  return {
    type: GMEMB_ADDING_MANAGER_ERROR,
    error,
  }
}

export function removingManager() {
  return {
    type: GMEMB_REMOVING_MANAGER,
  }
}

export function removingManagerSuccess(memberId) {
  return {
    type: GMEMB_REMOVING_MANAGER_SUCCESS,
    memberId,
  }
}

export function removingManagerError(error) {
  return {
    type: GMEMB_REMOVING_MANAGER_ERROR,
    error,
  }
}

const initialState = {
  isFetching: false,
  isCreating: false,
  error: '',
  groupsList: null,
  groupCreated: null,
  users: null,
  isFetchingUsers: false,
  activeGroup: null,
  isSavingMemberOrLeader: false,
}

export function groups (state = initialState, action) {
  switch (action.type) {
    case FETCHING_GROUPS :
      return {
        ...state,
        isFetching: true,
      }
    case FETCHING_GROUPS_FAILURE :
      return {
        ...state,
        error: action.error,
        isFetching: false,
      }
    case FETCHING_GROUPS_SUCCESS :
      return {
        ...state,
        groupsList: action.groupsList,
        isFetching: false,
        error: ''
      }
    case CREATING_GROUPS :
      return {
        ...state,
        isCreating: true,
      }
    case CREATING_GROUPS_FAILURE :
      return {
        ...state,
        isCreating: false,
        error: action.error
      }
    case CREATING_GROUPS_SUCCESS :
      return {
        ...state,
        isCreating: false,
        error: '',
        groupCreated: action.groupCreated,
      }
    case G_FETCHING_USERS :
      return {
        ...state,
        isFetchingUsers: true,
      }
    case G_FETCHING_USERS_SUCCESS :
      return {
        ...state,
        isFetchingUsers: false,
        users: action.users,
        error: '',
      }
    case G_FETCHING_USERS_ERROR :
      return {
        ...state,
        isFetchingUsers: false,
        error: action.error,
      }
    case GMEMB_SET_ACTIVE_GROUP : 
      return {
        ...state,
        activeGroup: action.activeGroup,
      }
    case GMEMB_ADDING_MEMBER :
      return {
        ...state,
        isSavingMemberOrLeader: true,
      }
    case GMEMB_ADDING_MEMBER_SUCCESS :
      return {
        ...state,
        error: '',
        isSavingMemberOrLeader: false,
        activeGroup: {
          ...state.activeGroup,
          members: {
            ...state.activeGroup.members,
            [action.memberId]: true,
          },
        }
      }
    case GMEMB_ADDING_MEMBER_ERROR :
      return {
        ...state,
        error: action.error,
        isSavingMemberOrLeader: false,
      }
    case GMEMB_REMOVING_MEMBER :
      return {
        ...state,
        isSavingMemberOrLeader: true,
      }
    case GMEMB_REMOVING_MEMBER_SUCCESS :
      return {
        ...state,
        error: '',
        activeGroup: {
          ...state.activeGroup,
          members: {
            ...state.activeGroup.members,
            [action.memberId]: false,
          }
        },
        isSavingMemberOrLeader: false,
      }
    case GMEMB_REMOVING_MEMBER_ERROR :
      return {
        ...state,
        isSavingMemberOrLeader: false,
        error: action.error,
      }
    case GMEMB_ADDING_MANAGER :
      return {
        ...state,
        isSavingMemberOrLeader: true,
      }
    case GMEMB_ADDING_MANAGER_SUCCESS :
      return {
        ...state,
        isSavingMemberOrLeader: false,
        error: '',
        activeGroup: {
          ...state.activeGroup,
          managers: {
            ...state.activeGroup.managers,
            [action.memberId]: true,
          },
        }
      }
    case GMEMB_ADDING_MANAGER_ERROR :
      return {
        ...state,
        error: action.error,
        isSavingMemberOrLeader: false,
      }
    case GMEMB_REMOVING_MANAGER :
      return {
        ...state,
        isSavingMemberOrLeader: true,
      }
    case GMEMB_REMOVING_MANAGER_SUCCESS :
      return {
        ...state,
        isSavingMemberOrLeader: false,
        error: '',
        activeGroup: {
          ...state.activeGroup,
          managers: {
            ...state.activeGroup.managers,
            [action.memberId]: false,
          },
        }
      }
    case GMEMB_REMOVING_MANAGER_ERROR :
      return {
        ...state,
        isSavingMemberOrLeader: false,
        error: action.error,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/groups.js